import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase";
import VueYoutube from 'vue-youtube';
import VueHead from 'vue-head';

declare global {
  interface Window {
    MP_SDK: any
  }
}
window.MP_SDK = window.MP_SDK || {};

Vue.config.productionTip = false;
Vue.use(VueYoutube);
Vue.use(VueHead, { separator: '-'});

/**
 * Firebaseの初期設定
 */
const firebaseConfig = {
  apiKey: "AIzaSyApUedbhrjTSzVfFQau8HJk6nZ01Rvt-HQ",
  authDomain: "vr-mockup.firebaseapp.com",
  databaseURL: "https://vr-mockup.firebaseio.com",
  projectId: "vr-mockup",
  storageBucket: "vr-mockup.appspot.com",
  messagingSenderId: "436299122013",
  appId: "1:436299122013:web:ee50e1703d1612e19254b4"
};
// Firebaseをイニシャライズ
firebase.initializeApp(firebaseConfig);
console.log('===========> Initialize Firebase');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
